import { Observable, of, EMPTY } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { AjaxError } from 'rxjs/ajax'
import { setUnexpectedErrorActionCreator } from 'actions/globalActions'
import { getErrorType } from 'helpers/errorHelpers'
import { ajaxCatch } from 'rxOperators/ajaxCatch'

export const end = <T>(callback: (value: T) => void) => (source: Observable<T>) => {
  return source.pipe(
    mergeMap((a) => {
      callback(a)
      return EMPTY
    }),
    ajaxCatch((error: AjaxError) => of(setUnexpectedErrorActionCreator(getErrorType(error), error, true)))
  )
}
